export default __webpack_public_path__ + "static/media/img-mwa-3-mobile.d64c636f.png";